module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Sushi-ce57e3f8a8912fa9f3d6de77297f0c31.svg";